import type * as React from 'react';
import type { JobSearchResultResponse } from '@doda/api-client/aspida/@types';
import { Favorite } from 'components/Favorite';

/**
 * Favoriteコンポーネントのプロパティ型
 */
export type FavoriteProps = React.ComponentProps<typeof Favorite>;

/**
 * ブックマークのURL定数
 */
const BOOK_MARK_URL = '/dcfront/bookmark/bookmarkList/';

/**
 * FavoriteButtonコンポーネントのプロパティ型
 */
export interface FavoriteButtonProps {
  /** 求人ID */
  jid: NonNullable<JobSearchResultResponse['jid']>;
  /** ブックマークされているかどうか */
  isBookmarked: JobSearchResultResponse['isBookmarkSaved'];
  /** 応募済みかどうか */
  isApplied: JobSearchResultResponse['isApplied'];
  /** ブックマークリストへのURLクエリ（任意）*/
  bookmarkUrlQuery?: string | undefined;
  /** お気に入りボタンのクリックハンドラー（任意）*/
  onBookmark?: FavoriteProps['onClickFavorite'];
  /** ブックマークリスト画面への遷移ハンドラー（任意）*/
  onNavigateToBookmarkList?: FavoriteProps['onClickSaved'];
}

/**
 * 気になるボタンコンポーネント
 * @param {FavoriteButtonProps} props - コンポーネントのプロパティ
 * @returns {JSX.Element} FavoriteButtonのJSX要素
 */
export const FavoriteButton = ({
  jid,
  isBookmarked = false,
  isApplied = false,
  bookmarkUrlQuery,
  onBookmark,
  onNavigateToBookmarkList,
}: FavoriteButtonProps) => {
  const bookmarkListUrl = bookmarkUrlQuery
    ? `${BOOK_MARK_URL}?${bookmarkUrlQuery}`
    : BOOK_MARK_URL;

  return (
    <Favorite
      size="M"
      width="200px"
      jid={jid}
      isBookmarked={isBookmarked}
      isApplied={isApplied}
      requestBody={{ device: 'PC' }}
      bookmarkListUrl={bookmarkListUrl}
      onClickFavorite={onBookmark}
      onClickSaved={onNavigateToBookmarkList}
    />
  );
};
